import { render, staticRenderFns } from "./TheWelcomeModal.vue?vue&type=template&id=0057328e&scoped=true&"
import script from "./TheWelcomeModal.vue?vue&type=script&lang=js&"
export * from "./TheWelcomeModal.vue?vue&type=script&lang=js&"
import style0 from "./TheWelcomeModal.vue?vue&type=style&index=0&id=0057328e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0057328e",
  null
  
)

export default component.exports